export default __webpack_public_path__ + "static/media/logo-thrivepass.c36351fe.png";